export default {
  title: 'Agregar archivo: {{slot}}',
  replace_title: 'Reemplazar archivo: {{slot}}',
  replace_description: 'El archivo nuevo sustituye a este. Conservamos el anterior en nuestros registros.',
  form: {
    kind: {
      label: 'Tipo de identificación',
      options: {
        passport: 'Pasaporte',
        driver_license: 'Licencia de conducir',
        id_card: 'Carné de identidad',
        residence_permit: 'Permiso de residencia',
      },
    },
    front: {
      label: 'Frente',
    },
    back: {
      label: 'Reverso',
    },
    file: {
      label: 'Archivo',
    },
    expires_at: {
      label: 'Válido hasta',
      placeholder: 'Seleccionar una fecha',
    },
    holder: {
      label: '¿De quién es esta identificación?',
      options: {
        owner: 'Mía, del propietario',
        partner: 'De un socio',
      },
    },
    holder_name: {
      label: 'Nombre del socio',
      placeholder: 'Nombre y apellido',
    },
  },
  accepted_files: 'PDF, JPG o PNG, hasta {{max}} MB.',
  accepted_images_min: 'La foto debe tener al menos {{min}} KB.',
  errors: {
    file_type: 'Solo se aceptan archivos PDF, JPG o PNG.',
    file_too_large: 'El archivo supera los {{max}} MB.',
    file_too_small: 'La foto debe tener al menos {{min}} KB.',
  },
  buttons: {
    select_file: 'Seleccionar archivo',
    submit: 'Subir',
    cancel: 'Cancelar',
  },
  toasts: {
    success: 'Archivo subido',
    error: 'No se pudo subir el archivo.',
  },
};
